import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import MachineCard from '../machine-card/machineCard';

class MachineLink extends React.Component {
  static propTypes = {
    machineName: PropTypes.string.isRequired,
  };

  getMachineURL = () => {
    const {
      machine,
      data,
    } = this.props;

    const machineName = machine.machine_type_name.text;

    let url = '';

    if(machineName === "c'2" || machineName === "c'2m" || machineName === "c'2ct") {
      url = 'cameo';
    } else {
      data.map(item => {
        if(item.name === machineName) {
          url = item.url;
        }
      });
    }

    return url;
  };

  render() {
    const {
      machine
    } = this.props;

    const link = this.getMachineURL();

    return (
      <Fragment>
        <MachineCard name = { machine.machine_type_name.text } navImage = { machine.navigation_image.url } url = { link } />
      </Fragment>
    );
  }
}

export default MachineLink;
